import { title } from '../../../material-kit-react.js';

const productStyle = {
  section: {
    fontFamily: 'Roboto',
    paddingRight: '0',
    paddingLeft: '0',
    paddingTop: '70px',
    textAlign: 'center',
  },
  title: {
    ...title,
    fontFamily: 'Roboto',
    marginBottom: '1rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  description: {
    color: '#999',
    fontFamily: 'Roboto',
    fontSize: '20px',
  },
};

export default productStyle;
